angular.module('components.caImportEditorValidationErrors', [])
    .component('caImportEditorValidationErrors', {
        templateUrl: 'main/product/productimporteditor/components/importeditorvalidationerrors.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            validationErrors: '<',
            selectFileRows: '&',
            deselectFileRows: '&',
            validationErrorChangeCount: '=',
            numberOfFilteredRows: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope) {
    var vm = this;

    //Properties
    vm.errors = [];
    vm.warnings = [];
    vm.hiddenWarningDisplayMessages = [];
    vm.showWarnings = true;
    vm.showErrors = true;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.selectValidationError = selectValidationError;
    vm.hideWarning = hideWarning;
    vm.getNumberOfShownErrors = getNumberOfShownErrors;
    vm.getNumberOfShownWarnings = getNumberOfShownWarnings;
    vm.resetFilters = resetFilters;
    vm.resetWarnings = resetWarnings;

    function onInit() {
        $scope.$watchCollection('vm.validationErrors', function(oldValue, newValue) {
            vm.errors = _.filter(vm.validationErrors, function(validationError) {
                return validationError.severity === 'error';
            });
            vm.warnings = _.filter(vm.validationErrors, function(validationError) {
                return validationError.severity === 'warning';
            });
            // Hide previously hidden messages
            _.forEach(vm.warnings, function(warning) {
                if (_.find(vm.hiddenWarningDisplayMessages, function(w) { return w === warning.displayMessage; })) {
                    warning.hide = true;
                }
            });
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

    function resetFilters() {
        vm.deselectFileRows();
    }

    function hideWarning(warning) {
        warning.hide = true;
        vm.validationErrorChangeCount++;
        // Remember hidden warning messages
        if (!_.find(vm.hiddenWarningDisplayMessages, function(m) { return m === warning.displayMessage; })) {
            vm.hiddenWarningDisplayMessages.push(warning.displayMessage);
        }
    }

    function resetWarnings() {
        vm.hiddenWarningDisplayMessages = [];
        _.forEach(vm.warnings, function(warning) {
            warning.hide = false;
        });
        vm.validationErrorChangeCount++;
    }

    function selectValidationError(validationError) {
        if (vm.selectFileRows) {
            vm.selectFileRows({ fileRows: validationError.fileRows, displayMessage: validationError.displayMessage });
        }
    }

    function getNumberOfShownWarnings() {
        var count = 0;
        _.forEach(vm.warnings, function(warning) {
            if (!warning.hide) {
                count++;
            }
        });
        return count;
    }

    function getNumberOfShownErrors() {
        var count = 0;
        _.forEach(vm.errors, function() { count++; });
        return count;
    }
}
